// CRO
export const DEFAULT_INPUT_CURRENCY = 'CRO'
// BUSD
export const DEFAULT_OUTPUT_CURRENCY = '0xc2132D05D31c914a87C6611C10748AEb04B58e8F'
